import { render, staticRenderFns } from "./productDetails.vue?vue&type=template&id=5f7dff3c&scoped=true&"
import script from "./productDetails.vue?vue&type=script&lang=ts&"
export * from "./productDetails.vue?vue&type=script&lang=ts&"
import style0 from "./productDetails.vue?vue&type=style&index=0&id=5f7dff3c&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7dff3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/project/xunjie/ams_old/ams-admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabItem } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
installComponents(component, {VBtn,VContainer,VFlex,VIcon,VLayout,VTab,VTabItem,VTabs})
